import { render } from "./PlgfDoubleMarkersResultFileEdit.vue?vue&type=template&id=4ab40065&scoped=true"
import script from "./PlgfDoubleMarkersResultFileEdit.vue?vue&type=script&lang=js"
export * from "./PlgfDoubleMarkersResultFileEdit.vue?vue&type=script&lang=js"

import "./PlgfDoubleMarkersResultFileEdit.vue?vue&type=style&index=0&id=4ab40065&lang=scss&scoped=true"
import "./PlgfDoubleMarkersResultFileEdit.vue?vue&type=style&index=1&id=4ab40065&lang=scss"
import "./PlgfDoubleMarkersResultFileEdit.vue?vue&type=style&index=2&id=4ab40065&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ab40065"]])

export default __exports__